<ol class="pt-3">
  <li class="start-1">
    <h6 class="pl-2 mb-4">
      {{ 'consent_privacy_and_data_protection_subtitle_1' | translate }}
    </h6>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p3' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p4' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p5' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_p6' | translate"></p>
  </li>
  <li>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_info' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_list1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_list2' | translate"></p>
  </li>

  <li>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p3' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_1_p4' | translate"></p>
  </li>
  <li>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2_p2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_2_p3' | translate"></p>
  </li>
  <li>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3_p2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_3_p3' | translate"></p>
  </li>
  <li>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_4' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_4_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_1_4_p2' | translate"></p>
  </li>

  <li>
    <h6 class="pl-2 mb-4">
      {{ 'consent_privacy_and_data_protection_subtitle_3' | translate }}
    </h6>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_p2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_list1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_list2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_3_list3' | translate"></p>
  </li>

  <li>
    <h6 class="pl-2 mb-4">
      {{ 'consent_privacy_and_data_protection_subtitle_4' | translate }}
    </h6>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_4_p1' | translate"></p>
  </li>

  <li>
    <h6 class="pl-2 mb-4">
      {{ 'consent_privacy_and_data_protection_subtitle_5' | translate }}
    </h6>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_p1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list1' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list2' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list3' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list4' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list5' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list6' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_list7' | translate"></p>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_5_p2' | translate"></p>
  </li>
  <li>
    <h6 class="pl-2 mb-4">
      {{ 'consent_privacy_and_data_protection_subtitle_6' | translate }}
    </h6>
    <p class="mb-4" [innerHTML]="'consent_privacy_and_data_protection_paragraph_6_p1' | translate"></p>
  </li>
</ol>
